import { useRestClient } from '@/contexts/QueryProvider'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'
// import { json } from '../../../../mock-data/activity-log/activity-skills-skills-test-project-local.json'
// import { TemplateSummaryResponse } from '../types'

// const mockData = json as TemplateSummaryResponse[]

export function useGetTemplateActivityLogByIds({
  entityId,
  templateId,
  appId: appIdProp,
  projectId: projectIdProp,
}: {
  entityId: number
  templateId: number
  appId?: number
  projectId?: number
}) {
  const { getTemplatesApiGetSpecificTemplateSummary } = useRestClient()
  const { appId: appIdContext, projectId: projectIdContext } = useAppContext()

  return getTemplatesApiGetSpecificTemplateSummary.useSuspenseQuery(
    {
      path: {
        applicationId: appIdProp || appIdContext!,
        projectId: projectIdProp || projectIdContext!,
        entityId,
        templateId,
      },
    }
    // { select: (_) => mockData }
    // { select: (_) => mockData.slice(0, -1) }
  )
}

export function useInvalidateTemplateActivityLogByIds({
  entityId,
  templateId,
}: {
  entityId: number
  templateId: number
}) {
  const { getTemplatesApiGetSpecificTemplateSummary } = useRestClient()
  const { appId, projectId } = useAppContext()
  return () =>
    getTemplatesApiGetSpecificTemplateSummary.invalidateQueries({
      parameters: {
        path: {
          applicationId: appId!,
          projectId: projectId!,
          entityId,
          templateId,
        },
      },
    })
}
